import './assets/main.css'
import 'vue-toastification/dist/index.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { options } from './utils/toastification'
import { applyEnvironmentFavicon, formatTitleWithEnvironment } from './utils/environment'

import App from './App.vue'
import i18n from './plugins/i18n'
import router from './router'
import Toast from 'vue-toastification'
import VueDOMPurifyHTML from 'vue-dompurify-html'
import DOMPurify from 'dompurify'
import lazyLoadDirective from './directives/lazy-load'

import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue, { type BugsnagPluginVueResult } from '@bugsnag/plugin-vue'
import BugsnagPerformance from '@bugsnag/browser-performance'

const bugsnagApiKey = import.meta.env.VITE_BUGSNAG_API_KEY
const appVersion = import.meta.env.VITE_APP_VERSION
const env = import.meta.env.VITE_ENV
// Bugsnagはローカル環境では無効化（本番/ステージング環境でのみ有効）
const isLocalEnv = env === 'local'
let bugsnagVue: BugsnagPluginVueResult | undefined
if (bugsnagApiKey && !isLocalEnv) {
  Bugsnag.start({
    apiKey: bugsnagApiKey,
    appVersion,
    plugins: [new BugsnagPluginVue()]
  })
  BugsnagPerformance.start({ apiKey: bugsnagApiKey, appVersion })
  bugsnagVue = Bugsnag.getPlugin('vue') as BugsnagPluginVueResult
}

applyEnvironmentFavicon()
document.title = formatTitleWithEnvironment(document.title)

const app = createApp(App)

app.directive('lazy', lazyLoadDirective)

// タブナビング攻撃を防ぐため、target="_blank"を持つリンクにrel="noopener noreferrer"を自動追加
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
    node.setAttribute('rel', 'noopener noreferrer')
  }
})

app.use(createPinia())
app.use(i18n)
app.use(router)
app.use(Toast, options)
app.use(VueDOMPurifyHTML, {
  default: {
    ADD_ATTR: ['target', 'rel']
  }
})
if (bugsnagVue) {
  app.use(bugsnagVue)
}

app.mount('#app')
